<div class="row">
  <div class="col-xs-12 col-12">
    <pre class="card card-block card-header mb-3" *ngFor="let message of messages">{{message}}</pre>
  </div>
  <div class="col-xs-12 col-12 mb-3">
    <div class="btn-group"
         dropdown
         (onShown)="handler('onShown')"
         (onHidden)="handler('onHidden')">
      <button id="button-visbility" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
              aria-controls="dropdown-visbility">
        Button dropdown <span class="caret"></span>
      </button>
      <ul id="dropdown-visbility" *dropdownMenu class="dropdown-menu"
          role="menu" aria-labelledby="button-visbility">
        <li role="menuitem"><a class="dropdown-item" href="#">Action</a></li>
        <li role="menuitem"><a class="dropdown-item" href="#">Another action</a></li>
        <li role="menuitem"><a class="dropdown-item" href="#">Something else here</a></li>
      </ul>
    </div>
  </div>
</div>
